/* eslint-disable no-lone-blocks */
/* eslint-disable no-unused-expressions */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import i18next from 'i18next';
import { ApolloProvider } from '@apollo/client';
import { Provider } from 'react-redux';
import { initReactI18next, I18nextProvider } from 'react-i18next';
import { Loading } from 'components';
import apolloClient from 'config/graphql';
import RouteHandler from './RouteHandler';
import store from './redux/store';
import enTranslations from './locales/en';
import idTranslations from './locales/id';
import './layouts/antd/index.scss';

const resources = {
  en: { messages: enTranslations },
  id: { messages: idTranslations },
};
const i18n = i18next.use(initReactI18next);
i18n.init({
  react: {
    wait: true,
  },
  resources: resources,
  lng: 'id',
  fallbackLng: 'en',
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
  },
  ns: ['messages'],
  defaultNS: 'messages',
  fallbackNS: [],
});

const App = () => (
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <ApolloProvider client={apolloClient}>
        <Suspense fallback={<Loading />}>
          <RouteHandler />
        </Suspense>
      </ApolloProvider>
    </Provider>
  </I18nextProvider>
);

ReactDOM.render(<App />, document.getElementById('root'));
